import { useEffect } from 'react';

// Component to track usage patterns and calculations
const CalculationTracker = ({ results, discountType, isVatRegistered }) => {
  useEffect(() => {
    // Only track when results are available (calculation completed)
    if (results && window.gtag) {
      // Detect if the user is running the app as an installed PWA (webapp) or in a standard browser
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true || document.referrer.includes('android-app://');
      const appMode = isStandalone ? 'webapp' : 'website';

      // Track the calculation event
      window.gtag('event', 'calculation_completed', {
        'event_category': 'engagement',
        'event_label': discountType,
        'value': parseFloat(results.originalPrice),
        'discount_type': discountType,
        'vat_registered': isVatRegistered ? 'yes' : 'no',
        'discount_amount': parseFloat(results.discount),
        'final_amount': parseFloat(results.billableAmount),
        'app_mode': appMode
      });

      // Track different price ranges
      const priceValue = parseFloat(results.originalPrice);
      let priceRange;

      if (priceValue < 100) {
        priceRange = 'under_100';
      } else if (priceValue < 500) {
        priceRange = '100_to_500';
      } else if (priceValue < 1000) {
        priceRange = '500_to_1000';
      } else if (priceValue < 5000) {
        priceRange = '1000_to_5000';
      } else {
        priceRange = 'over_5000';
      }

      window.gtag('event', 'price_range', {
        'event_category': 'calculation',
        'event_label': priceRange,
        'app_mode': appMode
      });
    }
  }, [results, discountType, isVatRegistered]);

  return null; // This component doesn't render anything
};

export default CalculationTracker;